import React, { useEffect, useContext, useState } from "react";
import { AccountContext } from "../../context/AccountContext";
import axios from "axios";
import { TARM_AWS_URL } from "../../api/api";
import Loading from "../Loading/Loading";
import { useToast } from "@chakra-ui/react";
import RankingList from "../Common/Ranking/RankingList";

const BatchOperations = () => {
  const { user } = useContext(AccountContext);
  const [isLoading, setLoading] = useState(true);
  const [batchOpList, setBatchOpList] = useState([]);
  const [source] = useState(axios.CancelToken.source());
  const toast = useToast();

  useEffect(() => {
    fetchAllBatchOps(user.email);
    return () => {
      if (source) source.cancel();
    };
  }, []);

  const fetchAllBatchOps = async (authorEmail) => {
    try {
      const response = await TARM_AWS_URL.get(
        "get-all-batch-op-items?author_email=" + authorEmail,
        {
          cancelToken: source.token,
        }
      );
      setBatchOpList(response.data);
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return isLoading ? (
    <Loading loading={isLoading} />
  ) : (
    <RankingList rankingList={batchOpList} rankingListType="Batch Operations List" routePath={'/home/batch-ops/progress'} />
  );
};

export default BatchOperations;
